module.exports = __webpack_public_path__ + "static/local-farm-837c8bc11d1d5a681416292b3ffc7519.svg";